import { BLEED, FLAP_GAP, GLUE_FLAP_WIDTH } from "./constants.js"
import { BOX_TYPES } from "./BoxTypes.js"

import * as svgGenerator from './svgGenerator/shippingBoxGenerator.js'

import Base from "./Base";
import Panel from "./Panel";

class ShippingBox extends Base {
  glueFlapWidth = 0;
  glueFlapWidthInPx = 0;
  flapHeight = 0;
  flapHeightInPx = 0;
  flapGap = 0;
  flapGapInPx = 0;
  shorterSide = 0;
  shorterSideInPx = 0;

  constructor(params) {
    super(params);

    // @TODO: Think about moving this
    this.type = BOX_TYPES.SHIPPING;

    this.glueFlapWidth = GLUE_FLAP_WIDTH;
    this.glueFlapWidthInPx = this.glueFlapWidth * this.pixelsPerInch;

    this.flapGap = FLAP_GAP;
    this.flapGapInPx = this.flapGap * this.pixelsPerInch;

    // @TODO rename ?
    this.setFlapDimensions();
    this.setCanvasDimensions();
    this.setControlsSize();
    this.panels = this.getPanels()
  }

  getPanels() {
    // Get box W, L, D, for simplicity
    const {
      width: W,
      length: L,
      depth: D,
    } = this;

    const GFW = this.glueFlapWidth

    // panel config objects
    let panels = [
      {
        name: "glueFlap",
        print: false,
        width: GFW,
        height: D,
        top: this.flapHeight + BLEED,
        left: BLEED,
        angle: 0,
        insideAngle: 0,
        cameraRotationH: "none",
        cameraRotationV: "none",
        lid: "open",
        path: function () {
          return `
            M ${this.left} ${this.top}
            L ${this.left + this.width} ${this.top}
            L ${this.left + this.width} ${this.top + this.height}
            L ${this.left} ${this.top + this.height}
            Z
          `
        }
      },
      {
        name: "side1TopFlap",
        print: true,
        width: L - 2*this.flapGap,
        height: this.flapHeight,
        top: BLEED,
        left: GFW + this.flapGap + BLEED,
        angle: 0,
        insideAngle: 0,
        cameraRotationH: "front",
        cameraRotationV: "high",
        lid: "closed",
        path: function () {
          return `
            M ${this.left} ${this.top}
            L ${this.left + this.width} ${this.top}
            L ${this.left + this.width} ${this.top + this.height}
            L ${this.left} ${this.top + this.height}
            Z
          `
        }
      },
      {
        name: "side2TopFlap",
        print: true,
        width: W - 2*this.flapGap,
        height: this.flapHeight,
        top: BLEED,
        left: GFW + this.flapGap + BLEED + L,
        angle: 0,
        insideAngle: 0,
        cameraRotationH: "right",
        cameraRotationV: "middle",
        lid: "open",
        path: function () {
          return `
            M ${this.left} ${this.top}
            L ${this.left + this.width} ${this.top}
            L ${this.left + this.width} ${this.top + this.height}
            L ${this.left} ${this.top + this.height}
            Z
          `
        }
      },
      {
        name: "side3TopFlap",
        print: true,
        width: L - this.flapGap * 2,
        height: this.flapHeight,
        top: BLEED,
        left: GFW + this.flapGap + BLEED + L + W,
        angle: 0,
        insideAngle: 0,
        cameraRotationH: "back",
        cameraRotationV: "high",
        lid: "closed",
        path: function () {
          return `
            M ${this.left} ${this.top}
            L ${this.left + this.width} ${this.top}
            L ${this.left + this.width} ${this.top + this.height}
            L ${this.left} ${this.top + this.height}
            Z
          `
        }
      },
      {
        name: "side4TopFlap",
        print: true,
        width: W - 2*this.flapGap,
        height: this.flapHeight,
        top: BLEED,
        left: GFW + this.flapGap + BLEED + L + W + L,
        angle: 0,
        insideAngle: 0,
        cameraRotationH: "left",
        cameraRotationV: "middle",
        lid: "open",
        path: function () {
          return `
            M ${this.left} ${this.top}
            L ${this.left + this.width} ${this.top}
            L ${this.left + this.width} ${this.top + this.height}
            L ${this.left} ${this.top + this.height}
            Z
          `
        }
      },
      {
        name: "side1",
        print: true,
        width: L,
        height: D,
        top: this.flapHeight + BLEED,
        left: GFW + BLEED,
        angle: 0,
        insideAngle: 0,
        cameraRotationH: "front",
        cameraRotationV: "middle",
        lid: "current",
        path: function () {
          return `
            M ${this.left} ${this.top}
            L ${this.left + this.width} ${this.top}
            L ${this.left + this.width} ${this.top + this.height}
            L ${this.left} ${this.top + this.height}
            Z
          `
        }
      },
      {
        name: "side2",
        print: true,
        width: W,
        height: D,
        top: this.flapHeight + BLEED,
        left: GFW + L + BLEED,
        angle: 0,
        insideAngle: 0,
        cameraRotationH: "right",
        cameraRotationV: "middle",
        lid: "current",
        path: function () {
          return `
            M ${this.left} ${this.top}
            L ${this.left + this.width} ${this.top}
            L ${this.left + this.width} ${this.top + this.height}
            L ${this.left} ${this.top + this.height}
            Z
          `
        }
      },
      {
        name: "side3",
        print: true,
        width: L,
        height: D,
        top: this.flapHeight + BLEED,
        left: GFW + L + BLEED + W,
        angle: 0,
        insideAngle: 0,
        cameraRotationH: "back",
        cameraRotationV: "middle",
        lid: "current",
        path: function () {
          return `
            M ${this.left} ${this.top}
            L ${this.left + this.width} ${this.top}
            L ${this.left + this.width} ${this.top + this.height}
            L ${this.left} ${this.top + this.height}
            Z
          `
        }
      },
      {
        name: "side4",
        print: true,
        width: W,
        height: D,
        top: this.flapHeight + BLEED,
        left: this.glueFlapWidth + 2*L + BLEED + W,
        angle: 0,
        insideAngle: 0,
        cameraRotationH: "left",
        cameraRotationV: "middle",
        lid: "current",
        path: function () {
          return `
            M ${this.left} ${this.top}
            L ${this.left + this.width} ${this.top}
            L ${this.left + this.width} ${this.top + this.height}
            L ${this.left} ${this.top + this.height}
            Z
          `
        }
      },
      {
        name: "side1BottomFlap",
        print: true,
        width: L - 2*this.flapGap,
        height: this.flapHeight,
        top: this.flapHeight + D + BLEED,
        left: GFW + this.flapGap + BLEED,
        angle: 0,
        insideAngle: 0,
        cameraRotationH: "front",
        cameraRotationV: "low",
        lid: "current",
        path: function () {
          return `
            M ${this.left} ${this.top}
            L ${this.left + this.width} ${this.top}
            L ${this.left + this.width} ${this.top + this.height}
            L ${this.left} ${this.top + this.height}
            Z
          `
        }
      },
      {
        name: "side2BottomFlap",
        print: false,
        width: W - 2*this.flapGap,
        height: this.flapHeight,
        top: this.flapHeight + D + BLEED,
        left: GFW + L + this.flapGap + BLEED,
        angle: 0,
        insideAngle: 0,
        cameraRotationH: "none",
        cameraRotationV: "none",
        lid: "current",
        path: function () {
          return `
            M ${this.left} ${this.top}
            L ${this.left + this.width} ${this.top}
            L ${this.left + this.width} ${this.top + this.height}
            L ${this.left} ${this.top + this.height}
            Z
          `
        }
      },
      {
        name: "side3BottomFlap",
        print: true,
        width: L - 2*this.flapGap,
        height: this.flapHeight,
        top: this.flapHeight + D + BLEED,
        left: GFW + L + W + this.flapGap + BLEED,
        angle: 0,
        insideAngle: 0,
        cameraRotationH: "back",
        cameraRotationV: "low",
        lid: "current",
        path: function () {
          return `
            M ${this.left} ${this.top}
            L ${this.left + this.width} ${this.top}
            L ${this.left + this.width} ${this.top + this.height}
            L ${this.left} ${this.top + this.height}
            Z
          `
        }
      },
      {
        name: "side4BottomFlap",
        print: false,
        width: W - 2*this.flapGap,
        height: this.flapHeight,
        top: this.flapHeight + D + BLEED,
        left: this.glueFlapWidth + 2*L + W + this.flapGap + BLEED,
        angle: 0,
        insideAngle: 0,
        cameraRotationH: "none",
        cameraRotationV: "none",
        lid: "current",
        path: function () {
          return `
            M ${this.left} ${this.top}
            L ${this.left + this.width} ${this.top}
            L ${this.left + this.width} ${this.top + this.height}
            L ${this.left} ${this.top + this.height}
            Z
          `
        }
      },
    ];

    // initialize and return panels
    return panels.map((panel) => new Panel(panel));
  }

  getDocumentWidth(withBleed = true) {
    let _bleed = withBleed ? 2 * this.bleed : 0
    return _bleed + this.glueFlapWidth + 2*this.width + 2*this.length;
  }

  getDocumentHeight(withBleed = true) {
    let _bleed = withBleed ? 2 * this.bleed : 0
    return _bleed + this.depth + 2*this.flapHeight;
  }

  // @TODO improve
  setFlapDimensions() {
    // flap height
    this.flapHeight = this.width / 2;
    this.flapHeightInPx = this.flapHeight * this.pixelsPerInch;
  }

  setCanvasDimensions() {
    this.shorterSide = Math.min(this.width, this.length);
    this.shorterSideInPx = this.shorterSide * this.pixelsPerInch;

    // canvas width
    this.canvasWidth =
      (this.width * 2 + this.length * 2 + this.glueFlapWidth + this.bleed * 2) * this.pixelsPerInch;
    // canvas height
    this.canvasHeight = (this.depth + this.shorterSide + this.bleed * 2) * this.pixelsPerInch;

    // canvas ratio
    this.ratio = this.canvasWidth > this.canvasHeight ? this.canvasHeight / this.canvasWidth : this.canvasWidth / this.canvasHeight;
  }

  getGeometrySvg() {
    return svgGenerator.getSvgForGeom(this)
  }

  get2DEditorSvg(printSide = 'outside') {
    return svgGenerator.get2DEditorSvg(this, printSide)
  }

  getOutlinePathWithBleed() {
    return svgGenerator.getOutlineWithBleed(this, false)
  }

  getNormalizedOutlinePathWithBleed(printSide = 'outside') {
    return svgGenerator.getOutlineWithBleed(this, true, printSide)
  }

  getOutlinePathWithoutNonPrintPanels(printSide = 'outside') {
    return svgGenerator.getOutlineWithoutNonPrintPanels(this, false, printSide)
  }

  getOutlinePath() {
    return svgGenerator.getOutline(this)
  }

  getCutlinesPath() {
    return svgGenerator.getCutlines(this)
  }
}

export default ShippingBox;
